import { render } from "./OnboardingAC.vue?vue&type=template&id=1434491e&scoped=true"
import script from "./OnboardingAC.vue?vue&type=script&lang=js"
export * from "./OnboardingAC.vue?vue&type=script&lang=js"

import "./OnboardingAC.vue?vue&type=style&index=0&id=1434491e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1434491e"]])

export default __exports__